module.exports = __webpack_public_path__ + "img/medicalCard.4b1021f5.png";